import { ELocale } from '~~/types/enums'

export const useLang = (_lang?: ELocale) => {
  const runtimeConfig = useRuntimeConfig()
  const i18nStore = useI18nStore()
  const { locale, t: $t } = useI18n()
  const nuxtApp = useNuxtApp()

  // 🔧 优先从插件中获取已检测的语言信息
  const detectedLanguage = nuxtApp.$detectedLanguage || 'cn'
  const detectedLocale = nuxtApp.$detectedLocale || 'zh'

  let lang: string
  let targetLang: ELocale
  console.log('17--3', detectedLanguage)
  // 使用插件检测的语言信息，忽略传入参数
  if (detectedLanguage === 'en') {
    lang = 'en'
    targetLang = ELocale.en
    locale.value = 'en'
  } else {
    lang = 'cn'
    targetLang = ELocale.cn
    locale.value = 'zh'
  }

  // 更新 i18nStore 保持兼容性
  i18nStore.setLang(targetLang)

  return { lang, $t }
}
